var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('participant-adherence-average-chart',{attrs:{"adherence-data":_vm.sections,"total-num":_vm.total,"percentage":_vm.calculateCompletedPercentage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }